import { cn } from "@/lib/cn";

type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  radius?: "md" | "lg";
  elevation?: "sm" | "lg";
};

const RADIUS = { md: "rounded-[16px]", lg: "rounded-[22px]" } as const;

/** 공통 surface 컨테이너 (배경/보더/그림자 토큰 캡슐화). */
export function Card({
  radius = "md",
  elevation = "sm",
  className,
  style,
  children,
  ...rest
}: CardProps) {
  return (
    <div
      className={cn("bg-surface", RADIUS[radius], className)}
      style={{
        border: "1px solid var(--line)",
        boxShadow: elevation === "lg" ? "var(--shadow-lg)" : "var(--shadow-sm)",
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
